import {
  GET_TRANSFER_TYPE_LIST_SUCCESS,
  GET_TRANSFER_TYPE_LIST_FAILED,
  RESET_GET_TRANSFER_TYPE_LIST,
  LOADING_GET_TRANSFER_TYPE_LIST,
  NETWORK_ERROR_GET_TRANSFER_TYPE_LIST,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminGetTransferTypeList = () => {
  // console.log("mking resetttt");
  return { type: RESET_GET_TRANSFER_TYPE_LIST };
};

const adminGetTransferTypeList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GET_TRANSFER_TYPE_LIST });
    await adminServices
      .post("getTransfertypeList", userData, {
        headers: { AuthToken: authTokenIs },
      })
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch({
              type: GET_TRANSFER_TYPE_LIST_SUCCESS,
              payload: res.data,
            });
            break;
          default:
            dispatch({
              type: GET_TRANSFER_TYPE_LIST_FAILED,
              payload: res.data,
            });
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GET_TRANSFER_TYPE_LIST,
          payload: err,
        });
      });
  };

export { resetAdminGetTransferTypeList, adminGetTransferTypeList };
